<template>
  <BuyerTwoColumnPage
    :title="title"
    subTitle="Acompanhe suas cotações!"
    :icon="icon"
    :section="section"
    :description="description"
    :getContent="getQuotesInProgress"
    labelCard="Sua avaliação"
    :sectionLeft="{
      title: 'Cotações ativas',
      labelCard: 'Sua cotação',
      subTitle:
        'Acompanhe suas cotações ativas que estão aguardando análise do anunciante.',
    }"
    :sectionRight="{
      title: 'Cotações superadas',
      labelCard: 'Cotação superada',
      subTitle: 'As que estão superadas, considere enviar uma nova cotação.',
    }"
    priceDescriptionPage="Sua cotação"
    noVehicleLabel="Você ainda não cotou nenhum veículo…"
    noVehicleRightLabel="Você ainda não possui cotações superadas"
    buyerScope="InProgress"
  />
  <QuickViewModal />
</template>

<script>
import { BUYER_SECTION_IN_PROGRESS } from "@/views/buyer/constants/BuyerSections";

import PlatformsMixins from "@/mixins/PlatformsMixins";
import BuyerComponentPagesMixins from "@/mixins/BuyerComponentPagesMixins";

import { getQuotesInProgress } from "@/services/api/BuyerServiceApi";

import BuyerTwoColumnPage from "../BuyerTwoColumnPage";
import QuickViewModal from "../../components/MakeEvaluationViewModal.vue";

export default {
  name: "QuotesInProgressPage",
  mixins: [PlatformsMixins, BuyerComponentPagesMixins],
  components: { BuyerTwoColumnPage, QuickViewModal },
  data: function () {
    return {
      ...BUYER_SECTION_IN_PROGRESS,
      title: "Cotações",
      section: "Em andamento",
    };
  },
  methods: {
    getQuotesInProgress,
  },
};
</script>

<style scoped>
.quotes-in-progress-page {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.quotes-in-progress-page-top {
  width: 100%;
}

.quotes-in-progress-page-content {
  margin-top: 4px;
  background-color: white;
  flex: 1;
}
</style>
